import getItemsWithMatchingRules from './getItemsWithMatchingRules';
import { ReturnItem } from '../../types/order';
import { ReturnRule } from '../../types/order-merchant';
import isReturnExpired from './isReturnExpired';
import isOutsideReturnWindow from './isOutsideReturnWindow';

export default function isManualApprovalRequired(
  items: Array<ReturnItem>,
  rules: Array<ReturnRule>,
  purchasedAt: string,
  returnWindowInDays: number | string | null,
  expiresAt: string | null
) {
  // check if the return has expired
  if (expiresAt) return isReturnExpired(expiresAt);

  // check the return window is valid
  if (
    returnWindowInDays &&
    isOutsideReturnWindow(purchasedAt, returnWindowInDays)
  )
    return true;

  const itemsWithRules = getItemsWithMatchingRules(items, rules);
  return itemsWithRules.length < items.length;
}
